import React from "react";
import { useDispatch } from "react-redux";
import { setQuery } from "../../store/slices/colaboradoresSlice.ts";

const FiltrosColaboradoresSuspendidos = () => {
  const dispatch = useDispatch();
  const [search, setSearch] = React.useState("");
  const [timer, setTimer] = React.useState<any>(null);
  const [showPill, setShowPill] = React.useState(false);

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setSearch(newValue);
    if (newValue === "") {
      setShowPill(false);
    } else {
      setShowPill(true);
    }
    if (timer) {
      clearTimeout(timer);
    }
    setTimer(
      setTimeout(() => {
        const queryString = newValue
          ? `search=${encodeURIComponent(newValue)}`
          : "";
        dispatch(setQuery(queryString));
        setTimer(null);
      }, 500)
    );
  };

  const removeFilter = () => {
    setSearch("");
    setShowPill(false);
    dispatch(setQuery(""));
  };

  return (
    <div>
      <div className="input-group mb-2">
        <div className="flex-fill position-relative">
          <div className="input-group">
            <div
              className="input-group-text position-absolute top-0 bottom-0 bg-none border-0 start-0"
              style={{ zIndex: 10 }}
            >
              {timer ? (
                <i className="fa fa-spinner fa-spin"></i>
              ) : (
                <i className="fa fa-search opacity-5"></i>
              )}
            </div>
            <input
              type="text"
              className="form-control px-35px bg-light"
              placeholder="Buscar por nombre..."
              id="name"
              name="name"
              onChange={handleSearchChange}
              value={search}
            />
          </div>
        </div>
      </div>
      <div className="mb-3">
        {showPill && search && (
          <div className="badge bg-primary text-white fs-6 me-2 position-relative pe-4">
            Búsqueda: {search}
            <button
              type="button"
              className="btn-close btn-close-white position-absolute top-0 end-0 mt-1 me-1 ps-1"
              aria-label="Close"
              onClick={removeFilter}
            ></button>
          </div>
        )}
      </div>
    </div>
  );
};

export default FiltrosColaboradoresSuspendidos;

